import React, { useState } from 'react';
import { ArrowUpRight, Plus } from 'lucide-react';

const FAQSection = ({
  title,
  subtitle,
  faqs: customFaqs
}) => {
  const [activeFaq, setActiveFaq] = useState(null);

  const defaultFaqs = [
    {
      question: "What Is Scan To BIM?",
      answer: "Scan to BIM is the process of capturing a physical space using 3D laser scanners to create an accurate Point Cloud, which is then converted into a highly precise Building Information Model (BIM)."
    },
    {
      question: "Who Uses Scan To BIM Services?",
      answer: "Architects, engineers, general contractors, and facility managers use Scan to BIM for renovation, retrofitting, asset management, and quality control."
    },
    {
      question: "What Kind Of Projects Benefit From Scan To BIM?",
      answer: "Projects involving heritage buildings, complex industrial facilities, existing office spaces, and large-scale renovations where as-built documentation is missing or outdated benefit the most."
    },
    {
      question: "What Software Is Used For Scan To BIM?",
      answer: "We use industry-leading software such as Autodesk Revit, Navisworks, AutoCAD, ReCap Pro, and various Point Cloud processing tools to ensure the highest accuracy."
    },
    {
      question: "Do You Provide On-Site Talent?",
      answer: "Yes, we can provide dedicated on-site personnel for project management or scanning supervision, depending on the project's scale and requirements."
    },
    {
      question: "Why Should We Trust Your Service?",
      answer: "With years of experience and a proven track record of delivering high-precision BIM models, we prioritize quality, security, and strict adherence to international standards."
    },
    {
      question: "What Sets Your Service Apart From Other Providers?",
      answer: "Our unique blend of technical expertise, rapid turnaround times, and highly competitive pricing, combined with a dedicated support team, makes us a preferred partner for global BIM projects."
    },
    {
      question: "What If The Talent Isn't Available During US-Time Hours?",
      answer: "We maintain flexible working hours and overlapping shifts to ensure smooth communication and collaboration across different time zones, including full coverage during US business hours."
    },
    {
      question: "What Happens If The Talent Doesn't Meet The Project's Expectations?",
      answer: "We provide a satisfaction guarantee. If the output doesn't meet the initial specifications, we offer immediate revisions and a dedicated quality assurance process to resolve any issues."
    }
  ];

  const faqs = customFaqs || defaultFaqs;

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">
          {title || <><span className="text-primary">Frequently Asked</span> Questions</>}
        </h2>
        {subtitle && <p className="faq-subtitle">{subtitle}</p>}

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeFaq === index ? 'active' : ''}`}
              onClick={() => toggleFaq(index)}
            >
              <div className="faq-question-row">
                <span className="faq-question">
                  {faq.question}
                </span>
                <span className="faq-icon">
                  <Plus size={28} strokeWidth={2.5} />
                </span>
              </div>

              <div className="faq-answer-wrapper">
                <div className="faq-answer">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-footer">
          <p className="faq-footer-text">Have More Questions?</p>
          <button className="faq-btn">
            Ask Our Expert <ArrowUpRight size={30} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
